<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <v-text-field
      :label="model.Caption"
      :disabled="isDisabled"
      :class="evaluateClasses(classes)"
      :value="getDataSourceField(model.Value)"
      :regular="isRegular"
      :solo="isSolo"
      :outlined="isOutlined"
      :filled="isFilled"
    ></v-text-field>
  </dr-wrapper>
  <dr-time-picker-component
    v-else-if="isVisible"
    :class="evaluateClasses(classes)"
    v-bind="$props"
    @callDataSourceAction="$emit('callDataSourceAction', $event)"
  ></dr-time-picker-component>
</template>

<script>
import inputMixin from '../../mixins/input-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import baseMixin from '../../mixins/base-mixin'
import drTimePickerComponent from './dr-time-picker-component'

export default {
  mixins: [inputMixin, baseMixin, widgetsWrapperMixin],
  components: {
    drTimePickerComponent
  }
}
</script>

<style>
</style>